// extracted by mini-css-extract-plugin
export default {"spacer":"components-Header-themes-BNO-styles__spacer--EuWqT","brandContainer":"components-Header-themes-BNO-styles__brandContainer--ZQE7V"};